import type { Tenant } from "../types/tenant";

export const formatDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const isDateSelectableForTenant = (
  date: Date,
  tenant?: Tenant | null,
) => {
  const day = date.getDay();
  if (day === 0) return false;
  if (day === 6 && !tenant?.schedulingAllowSaturday) return false;
  const weeklyAvailability = tenant?.schedulingWeeklyAvailability;
  const hasWeeklyConfig =
    !!weeklyAvailability && Object.keys(weeklyAvailability).length > 0;

  if (!hasWeeklyConfig) return true;

  const dayKey = {
    1: "mon",
    2: "tue",
    3: "wed",
    4: "thu",
    5: "fri",
    6: "sat",
  }[day];

  if (!dayKey) return false;

  const daySlots = weeklyAvailability?.[dayKey] ?? [];
  return daySlots.length > 0;
};
